module.exports = __webpack_public_path__ + "img/shopping-bag.49b7d93c.svg";